<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card>
        <l-map 
          v-if="showMap"
          :zoom="zoom"
          :center="center"
          :options="mapOptions"
          style="height: 80vH"
          @update:center="centerUpdate"
          @update:zoom="zoomUpdate"
        >
          <l-tile-layer
            :url="url"
          />
          <span v-if="this.$route.params.jenis!='TMA'">
            <span v-if="devices.condition === 'Hujan'">
              <l-marker 
                :lat-lng="devices.map"
                :icon="devices.icon"
                >
                <l-popup>
                  <div>
                    {{devices.station}} <br> {{devices.location}}
                    <p>
                      Status: {{devices.condition}}
                    </p>
                  </div>
                </l-popup>
              </l-marker>
            </span>
            <span v-if="devices.condition === 'Tidak Hujan'">
              <l-marker 
                :lat-lng="devices.map"
                :icon="devices.icon"
                >
                <l-popup>
                  <div>
                    {{devices.station}} <br> {{devices.location}}
                    <p>
                      Status: {{devices.condition}}
                    </p>
                  </div>
                </l-popup>
              </l-marker>
            </span>
            <span v-if="devices.condition!='Hujan' && devices.condition!=='Tidak Hujan' && devices.condition!=='Mati'">
              <l-marker 
                :lat-lng="devices.map"
                :icon="devices.icon"
                >
                <l-popup>
                  <div>
                    {{devices.station}} <br> {{devices.location}}
                    <p>
                      Status: {{devices.condition}}
                    </p>
                  </div>
                </l-popup>
              </l-marker>
            </span>
            <span v-if="devices.condition==='Mati'">
              <l-marker 
                :lat-lng="devices.map"
                :icon="devices.icon"
                >
                <l-popup>
                  <div>
                    {{devices.station}} <br> {{devices.location}}
                    <p>
                      Status: {{devices.condition}}
                    </p>
                  </div>
                </l-popup>
              </l-marker>
            </span>
          </span>

          <!-- TMA -->
          <span v-else>
            <span v-if="devices.condition === 'Bahaya'">
              <l-marker 
                :lat-lng="devices.map"
                :icon="devices.icon"
                >
                <l-popup>
                  <div>
                    {{devices.station}} <br> {{devices.location}}
                    <p>
                      Status: {{devices.condition}}<br>
                      Tinggi: {{devices.satuan=='cm'? Math.round(devices.ketinggian*100) : devices.ketinggian}} {{devices.satuan}}<br>
                      Battery: {{devices.volt}} Volt <br>
                      Signal: <v-icon v-if="parseInt(devices.signal)>23" color="success">mdi-signal-cellular-3</v-icon> <v-icon v-else-if="parseInt(devices.signal)>15" color="yellow accent-4">mdi-signal-cellular-2</v-icon> <v-icon v-else-if="parseInt(devices.signal)>8" color="warning">mdi-signal-cellular-1</v-icon> <v-icon v-else color="error">mdi-signal-cellular-outline</v-icon>
                    </p>
                  </div>
                </l-popup>
              </l-marker>
            </span>
            <span v-if="devices.condition === 'Evakuasi'">
              <l-marker 
                :lat-lng="devices.map"
                :icon="devices.icon"
                >
                <l-popup>
                  <div>
                    {{devices.station}} <br> {{devices.location}}
                    <p>
                      Status: {{devices.condition}}<br>
                      Tinggi: {{devices.satuan=='cm'? Math.round(devices.ketinggian*100) : devices.ketinggian}} {{devices.satuan}}<br>
                      Battery: {{devices.volt}} Volt <br>
                      Signal: <v-icon v-if="parseInt(devices.signal)>23" color="success">mdi-signal-cellular-3</v-icon> <v-icon v-else-if="parseInt(devices.signal)>15" color="yellow accent-4">mdi-signal-cellular-2</v-icon> <v-icon v-else-if="parseInt(devices.signal)>8" color="warning">mdi-signal-cellular-1</v-icon> <v-icon v-else color="error">mdi-signal-cellular-outline</v-icon>
                    </p>
                  </div>
                </l-popup>
              </l-marker>
            </span>
            <span v-if="devices.condition === 'Waspada'">
              <l-marker 
                :lat-lng="devices.map"
                :icon="devices.icon"
                >
                <l-popup>
                  <div>
                    {{devices.station}} <br> {{devices.location}}
                    <p>
                      Status: {{devices.condition}}<br>
                      Tinggi: {{devices.satuan=='cm'? Math.round(devices.ketinggian*100) : devices.ketinggian}} {{devices.satuan}}<br>
                      Battery: {{devices.volt}} Volt <br>
                      Signal: <v-icon v-if="parseInt(devices.signal)>23" color="success">mdi-signal-cellular-3</v-icon> <v-icon v-else-if="parseInt(devices.signal)>15" color="yellow accent-4">mdi-signal-cellular-2</v-icon> <v-icon v-else-if="parseInt(devices.signal)>8" color="warning">mdi-signal-cellular-1</v-icon> <v-icon v-else color="error">mdi-signal-cellular-outline</v-icon>
                    </p>
                  </div>
                </l-popup>
              </l-marker>
            </span>
            <span v-if="devices.condition === 'Normal'">
              <l-marker 
                :lat-lng="devices.map"
                :icon="devices.icon"
                >
                <l-popup>
                  <div>
                    {{devices.station}} <br> {{devices.location}}
                    <p>
                      Status: {{devices.condition}}<br>
                      Tinggi: {{devices.satuan=='cm'? Math.round(devices.ketinggian*100) : devices.ketinggian}} {{devices.satuan}}<br>
                      Battery: {{devices.volt}} Volt <br>
                      Signal: <v-icon v-if="parseInt(devices.signal)>23" color="success">mdi-signal-cellular-3</v-icon> <v-icon v-else-if="parseInt(devices.signal)>15" color="yellow accent-4">mdi-signal-cellular-2</v-icon> <v-icon v-else-if="parseInt(devices.signal)>8" color="warning">mdi-signal-cellular-1</v-icon> <v-icon v-else color="error">mdi-signal-cellular-outline</v-icon>
                    </p>
                  </div>
                </l-popup>
              </l-marker>
            </span>
            <span v-if="devices.condition === 'Mati'">
              <l-marker 
                :lat-lng="devices.map"
                :icon="devices.icon"
                >
                <l-popup>
                  <div>
                    {{devices.station}} <br> {{devices.location}}
                    <p>
                      Status: {{devices.condition}}<br>
                      Tinggi: {{devices.satuan=='cm'? Math.round(devices.ketinggian*100) : devices.ketinggian}} {{devices.satuan}}<br>
                      Battery: {{devices.volt}} Volt <br>
                      Signal: <v-icon v-if="parseInt(devices.signal)>23" color="success">mdi-signal-cellular-3</v-icon> <v-icon v-else-if="parseInt(devices.signal)>15" color="yellow accent-4">mdi-signal-cellular-2</v-icon> <v-icon v-else-if="parseInt(devices.signal)>8" color="warning">mdi-signal-cellular-1</v-icon> <v-icon v-else color="error">mdi-signal-cellular-outline</v-icon>
                    </p>
                  </div>
                </l-popup>
              </l-marker>
            </span>
          </span>
        </l-map>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { db }from "@/firebase/db.js"
// import moment from 'moment'
import { latLng, icon } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup,  } from "vue2-leaflet";

import { Icon } from 'leaflet';

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});


export default {
  name: "Example",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
  },
  data() {
    return {
      deviceEvent:null,
      settingEvent:null,
      zoom: 8,
      center: latLng(-6.87, 107.579),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      Rlatlng: latLng(-6.87, 107.579),
      devices:null,
      infoTime:0,
      mapOptions: {
        zoomSnap: 0.5
      },
      conditions:null,
      showMap: true,
      closeButton: false,
      Bicon: icon({
        iconRetinaUrl: require('@/assets/Map/Location_30px.png'),
        iconUrl: require('@/assets/Map/Location_30px.png'),
        iconAnchor: [14,28],
        popupAnchor: [1,-28],
        shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        shadowAnchor: [14,38]
      }),
      Ricon: icon({
        iconRetinaUrl: require('@/assets/Map/RLocation_30px.png'),
        iconUrl: require('@/assets/Map/RLocation_30px.png'),
        iconAnchor: [14,28],
        popupAnchor: [1,-28],
        shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        shadowAnchor: [14,38]
      }),
      Gicon: icon({
        iconRetinaUrl: require('@/assets/Map/GLocation_30px.png'),
        iconUrl: require('@/assets/Map/GLocation_30px.png'),
        iconAnchor: [14,28],
        popupAnchor: [1,-28],
        shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        shadowAnchor: [14,38]
      }),
      Yicon: icon({
        iconRetinaUrl: require('@/assets/Map/YLocation_30px.png'),
        iconUrl: require('@/assets/Map/YLocation_30px.png'),
        iconAnchor: [14,28],
        popupAnchor: [1,-28],
        shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        shadowAnchor: [14,38]
      }),
      redTMA: icon({
        iconRetinaUrl: require('@/assets/Map/resized/redTMA.png'),
        iconUrl: require('@/assets/Map/resized/redTMA.png'),
        iconAnchor: [9,9],
        popupAnchor: [0,0],
        // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        // shadowAnchor: [14,38],
      }),
      greenTMA: icon({
        iconRetinaUrl: require('@/assets/Map/resized/greenTMA.png'),
        iconUrl: require('@/assets/Map/resized/greenTMA.png'),
        iconAnchor: [9,9],
        popupAnchor: [0,0],
        // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        // shadowAnchor: [14,38],
      }),
      yellowTMA: icon({
        iconRetinaUrl: require('@/assets/Map/resized/yellowTMA.png'),
        iconUrl: require('@/assets/Map/resized/yellowTMA.png'),
        iconAnchor: [9,9],
        popupAnchor: [0,0],
        // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        // shadowAnchor: [14,38],
      }),
      orangeTMA: icon({
        iconRetinaUrl: require('@/assets/Map/resized/orangeTMA.png'),
        iconUrl: require('@/assets/Map/resized/orangeTMA.png'),
        iconAnchor: [9,9],
        popupAnchor: [0,0],
        // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        // shadowAnchor: [14,38],
      }),
      greyTMA: icon({
        iconRetinaUrl: require('@/assets/Map/resized/greyTMA.png'),
        iconUrl: require('@/assets/Map/resized/greyTMA.png'),
        iconAnchor: [9,9],
        popupAnchor: [0,0],
        // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        // shadowAnchor: [14,38],
      }),
    };
  },
  mounted () {
    let loader = this.$loading.show()
    console.log(this.$route.params.jenis)
    if (this.$route.params.jenis=='TMA') {
      this.deviceEvent = db.collection('radar').doc(this.$route.params.mac).onSnapshot((doc) => {
        let icon=(Date.now()/1000 - parseInt(doc.data().timestamp) > parseInt(doc.data().periodic)*120)? this.greyTMA : doc.data().bahaya=="1" ? this.redTMA : doc.data().waspada=="1" ? this.yellowTMA : doc.data().evakuasi=="1" ? this.orangeTMA : this.greenTMA    
        this.infoTime=doc.data().periodic
        this.conditions=(Date.now()/1000 - parseInt(doc.data().timestamp) > parseInt(doc.data().periodic)*120)? 'Mati' : doc.data().bahaya=="1" ? 'Bahaya' : doc.data().waspada=="1" ? 'Waspada' : doc.data().evakuasi=="1" ? 'Evakuasi' : 'Normal'
        this.devices={
          icon: icon,
          station: doc.data().station,
          map:latLng(parseFloat(doc.data().latitude),parseFloat(doc.data().longitude)),
          location:doc.data().location,
          condition:this.conditions,
          satuan: doc.data().satuan,
          signal:doc.data().signal,
          volt: doc.data().volt,
          ketinggian: doc.data().ketinggian,
        } 
        loader.hide()   
      })
    }
    else {
      this.deviceEvent = db.collection('device').doc(this.$route.params.mac).onSnapshot((docDevice) => {
        let icon=null
        let time=Date.now()/1000     
        this.settingEvent = db.collection('setting').doc(this.$route.params.mac).onSnapshot((doc) => {
          this.infoTime=doc.data().infotime
          this.conditions=docDevice.data().condition
          if (time-parseInt(docDevice.data().time)>(120*parseInt(this.infoTime))) {
            icon=this.Yicon
            this.conditions= 'Mati'
          } else {
            if (docDevice.data().condition == 'Hujan') {
              icon=this.Bicon
            } else if (docDevice.data().condition == 'Tidak Hujan') {
              icon=this.Gicon
            } else {
              icon=this.Ricon
            }
          }
          this.devices={
            icon: icon,
            station: docDevice.data().station,
            map:latLng(parseFloat(docDevice.data().latitude),parseFloat(docDevice.data().longitude)),
            location:docDevice.data().location,
            condition:this.conditions
          } 
          loader.hide()
        })
      })
    } 
  },
  methods: {
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    showLongText() {
      this.showParagraph = !this.showParagraph;
    },
    closeButtons () {
      console.log("HELLO")
    }
  },
  // beforeDestroy() {
  //   this.settingEvent();
  //   this.deviceEvent();
  // }
};
</script>

<style lang="scss">
  .vue2leaflet-map {
    z-index: 1;
  }
</style>
